import classNames from 'classnames/bind';
import styles from './AliasHeading.module.css';
import { BACK } from '../../../constants';
import { useNavigate } from 'react-router';
import { removeFileExtension } from '../../../utils/util';

interface AliasHeading {
  alias: string;
  suffix: string;
  name?: string;
  title?: string;
  hasBackButton?: boolean;
}

export default function AliasHeading({
  alias,
  suffix,
  name = '',
  title = '',
  hasBackButton = false,
}: AliasHeading) {
  const cx = classNames.bind(styles);
  const navigate = useNavigate();

  return (
    <div className={cx('dash_top', { st_detail: hasBackButton })}>
      {hasBackButton && (
        <div className={cx('btn_wrap')}>
          <button
            className={cx('btn', 'backspace')}
            onClick={() => navigate(-1)}
          >
            <span className={cx('blind')}>{BACK}</span>
          </button>
        </div>
      )}
      <h2
        dangerouslySetInnerHTML={{
          __html: suffix
            .replace('{user}', `${alias}${name && `(${name})`}`)
            .replace('{ebook}', removeFileExtension(title)),
        }}
      ></h2>
    </div>
  );
}
